import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import Menu, { MenuItem } from 'components/common/Menu';
import DeleteMenu from 'components/common/DeleteMenu';
import IconButton from 'components/common/IconButton';
import IconMoveVert from 'components/icons/IconMoveVert';
import IconMoreVert from 'components/icons/IconMoreVert';
import SalesRepresentativeCreateEditDialog from 'components/settings/SalesRepresentativeCreateEditDialog';
import IconLink from 'components/icons/IconLink';
import Tooltip from 'components/common/Tooltip';
import Typography from '@material-ui/core/Typography';
import Link from 'components/common/Link';

import pxToRem from 'styles/pxToRem';
import pxToEm from 'styles/pxToEm';
import splitLongWords from 'utils/splitLongWords';

const styles = theme => ({
  gridItemShrink: {
    flexShrink: 1,
  },
  gridItem: {
    display: 'flex',
    minHeight: 48,
    alignItems: 'center',
  },
  gridItemLink: {
    minWidth: 24,
  },
  iconMoreVert: {
    width: 24,
    height: 24,
  },
  iconLink: {
    color: theme.palette.primary[500],
    marginBottom: -4,
  },
  tooltipList: {
    textAlign: 'left',
  },
  buttonMove: {
    position: 'relative',
    top: 1,
  },
  iconMoveVert: {
    width: 10,
    height: 16,
  },
  desktopOnly: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
});

class SalesRepresentativesItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      editDialogOpen: false,
      deleteMenuOpen: false,
    };

    this.onMenuButtonClick = this.onMenuButtonClick.bind(this);
    this.onMenuClose = this.onMenuClose.bind(this);
    this.onEditMenuItemClick = this.onEditMenuItemClick.bind(this);
    this.onEditDialogClose = this.onEditDialogClose.bind(this);
    this.onDeleteMenuItemClick = this.onDeleteMenuItemClick.bind(this);
    this.onDeleteCancel = this.onDeleteCancel.bind(this);
    this.onDeleteSubmit = this.onDeleteSubmit.bind(this);
  }

  onMenuButtonClick(event) {
    this.setState({
      anchorEl: event.currentTarget,
      deleteMenuOpen: false,
    });
  }

  onMenuClose() {
    this.setState({ anchorEl: null });
  }

  onEditMenuItemClick() {
    this.onMenuClose();
    this.setState({ editDialogOpen: true });
  }

  onEditDialogClose() {
    this.setState({ editDialogOpen: false });
  }

  onDeleteMenuItemClick() {
    this.setState({ deleteMenuOpen: true });
  }

  onDeleteCancel() {
    this.setState({ anchorEl: null });
  }

  onDeleteSubmit() {
    const { onRemove } = this.props;
    onRemove();
    this.setState({ anchorEl: null });
  }

  render() {
    const { Email, Phone, ID, dragHandleClassName, dragDisabled, dragged, classes, ...otherProps } = this.props;
    const { anchorEl, deleteMenuOpen, editDialogOpen } = this.state;
    const open = Boolean(anchorEl);
    return (
      <Grid
        className={classes.root}
        container
        spacing={0}
        wrap="nowrap"
        justify="space-between"
        alignItems="flex-start"
      >
        <Grid item className={classes.gridItem}>
          <IconButton
            className={classNames(classes.buttonMove, dragHandleClassName)}
            disabled={dragDisabled}
            tooltipContent={(!dragDisabled && !dragged) ? 'Drag it to Change Position' : null}
          >
            <IconMoveVert className={classes.iconMoveVert} />
          </IconButton>
        </Grid>
        <Grid item xs={3} className={classes.gridItem}>
          <Link
            onClick={this.onEditMenuItemClick}
            breakWord
            size="md"
          > 
            {splitLongWords(`${otherProps['First Name']} ${otherProps['Last Name']}`)}
          </Link>
        </Grid>
        <Grid item xs={4} className={classNames(classes.gridItem, classes.gridItemShrink, classes.desktopOnly)}>
          {Email !== null &&
            <Typography>
              {splitLongWords(Email)}
            </Typography>
          }
        </Grid>
        <Grid item xs={3} className={classes.gridItem}>
          <Typography>
            {Phone}
          </Typography>
        </Grid>
        <Grid item className={classNames(classes.gridItem, classes.gridItemLink)}>
          {(this.props['Referral Source'] && this.props['Referral Source'].length > 0) &&
            <Tooltip
              content={
                <div className={classes.tooltipList}>
                  <Typography variant="caption" gutterBottom>
                    Linked Referral Source:
                  </Typography>
                  {this.props['Referral Source'].map(item => (
                    <Typography key={item.ID}>
                      {item['Name of source']}
                    </Typography>
                  ))}
                </div>
              }
              placement="top"
            >
              <IconLink className={classes.iconLink} />
            </Tooltip>
          }
        </Grid>
        <Grid item>
          <IconButton
            aria-label="More"
            aria-owns={open ? `${ID}-sales-representative-more-menu` : null}
            aria-haspopup="true"
            onClick={this.onMenuButtonClick}
            tooltipContent="Open Menu"
          >
            <IconMoreVert
              className={classes.iconMoreVert}
            />
          </IconButton>
          <Menu
            id={`${ID}-sales-representative-more-menu`}
            anchorEl={this.state.anchorEl}
            open={open}
            onClose={this.onMenuClose}
            list={!deleteMenuOpen}
          >
            {deleteMenuOpen ? (
              <DeleteMenu
                text="Are you sure you want to remove this sales?"
                onCancel={this.onDeleteCancel}
                onSubmit={this.onDeleteSubmit}
                submitButtonText="Remove"
              />
            ) : (
              <Fragment>
                <MenuItem
                  onClick={this.onEditMenuItemClick}
                >
                  Edit
                </MenuItem>
                <MenuItem
                  color="warning"
                  onClick={this.onDeleteMenuItemClick}
                >
                  Remove
                </MenuItem>
              </Fragment>
            )}
          </Menu>
          <SalesRepresentativeCreateEditDialog
            form={`salesRepresentativeEdit-${ID}`}
            open={editDialogOpen}
            ID={ID}
            initialValues={{
              'First Name': otherProps['First Name'],
              'Last Name': otherProps['Last Name'],
              ...otherProps['Middle Name'] ? { 'Middle Name': otherProps['Middle Name'] } : {},
              Phone,
              ...Email ? { Email } : {},
              ...otherProps['Referral Source'] ? { 'Referral Source': otherProps['Referral Source'].map(item => ({
                value: item.ID,
                label: item['Name of source'],
              }))} : {},
            }}
            onClose={this.onEditDialogClose}
          />
        </Grid>
      </Grid>
    );
  }
}

SalesRepresentativesItem.propTypes = {
  ID: PropTypes.number.isRequired,
  'First Name': PropTypes.string.isRequired,
  'Last Name': PropTypes.string.isRequired,
  Email: PropTypes.string,
  Phone: PropTypes.string.isRequired,
  dragHandleClassName: PropTypes.string,
  dragDisabled: PropTypes.bool,
  dragged: PropTypes.bool,
  onRemove: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    iconMoreVert: PropTypes.string.isRequired,
  }).isRequired,
};

SalesRepresentativesItem.defaultProps = {
  Email: null,
  dragHandleClassName: '',
  dragDisabled: false,
  dragged: false,
};

export default withStyles(styles)(SalesRepresentativesItem);



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/SalesRepresentatives/SalesRepresentativesItem.js